import { Chip, H5, Input } from '@base'
import { Button } from '@baseV2'
import { Devices, Spacings, Text } from '@styles'
import styled, { css } from 'styled-components'

export const Page = styled.div`
	padding: ${Spacings.SPACING_2B};
	color: ${({ theme }) => theme.palette.background.primary};
	background: ${({ theme }) => theme.palette.background.white};
	@media ${Devices.tablet} {
		padding: ${Spacings.SPACING_4B};
	}
`

export const Board = styled.div`
	width: 100%;
	overflow-x: auto;
	padding-bottom: 8px;
	@media ${Devices.mobile} {
		overflow-x: none;
	}
`

// export const Columns = styled.div`
// 	display: flex;
// 	gap: ${Spacings.SPACING_2B};
// 	min-height: 80vh;
// 	align-items: stretch;
// 	@media ${Devices.mobile} {
// 		display: grid;
// 		grid-template-columns: repeat(5, minmax(0, 1fr));
// 	}
// `

export const Columns = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	min-height: 80vh;
	align-items: stretch;

	@media ${Devices.mobile} {
		display: grid;
		grid-template-columns: repeat(${({ columns = 5 }) => columns}, minmax(0, 1fr));
	}
`

export const ColumnWrap = styled.div`
	min-width: 0;
	height: 80vh;
	display: flex;
	flex-direction: column;
	background: #f1f2f3;
	// border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: ${Spacings.SPACING_2B};
	flex: 0 0 100%;
	@media ${Devices.tablet} {
		flex: 0 0 320px; /* desktop column width */
	}
`

export const Header = styled.div`
	display: flex;
	align-items: center;
	// margin-bottom: ${Spacings.SPACING_4B};
	padding: 0 ${Spacings.SPACING_4B};
	justify-content: space-between;
	padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_4B};
`
export const Border = styled.hr`
	border: 0.01rem solid rgba(234, 241, 250, 1);
	border-color: ${({ theme }) => theme.palette.background.disabled};
`

export const ColumnTitle = styled.div`
	font-weight: ${Text.BOLD_600};
	font-size: ${Text.MEDIUM};
`
export const ChipWaaper = styled(Chip)`
	font-size: ${Text.SMALL};
	${({ status }) => {
		if (status === 'open_new') {
			return css`
				background: ${({ theme }) => theme.palette.background.Purple};
				color: ${({ theme }) => theme.palette.text.white};
			`
		}
	}}
`

export const ColumnList = styled.div`
	flex: 1 1 auto;
	overflow-y: auto;
	overflow-x: hidden;
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B} ${Spacings.SPACING_3B};
	min-height: 0;
	border-radius: ${Spacings.SPACING_3B};

	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
		display: none;
	}
`

export const Cards = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`

export const CardWrap = styled.div`
	display: flex;
	flex-direction: column;
`

export const CardBox = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
	box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
	cursor: all-scroll;
	user-select: none;
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	&:hover {
		border-color: rgba(15, 23, 42, 0.14);
		box-shadow: 0 6px ${Spacings.SPACING_4B} rgba(15, 23, 42, 0.1);
	}

	&:active {
		cursor: all-scroll;
	}

	width: 100%;
	min-width: 0;
`

export const CardTitle = styled.div`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.primary};
	cursor: pointer;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
`

export const CalendarToday = styled.div`
	font-size: ${Text.SMALL};
	display: flex;
	align-items: center;
	gap: 5px;
	color: ${({ theme }) => theme.palette.text.primary};
	& > svg {
		font-size: ${Text.LARGE};
	}

	min-width: 0;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const CardMeta = styled.div`
	margin-top: 4px;
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.palette.text.greyThree};

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;
`

export const EmptyHint = styled.div`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.palette.text.greyTwo};
	text-align: center;
	padding: ${Text.LARGE} 0;
`

export const Indicator = styled.div`
	height: 3px;
	border-radius: 999px;
	background: ${({ theme }) => theme.palette.secondary.main};
	box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.16);
	opacity: ${(p) => (p.$show ? 1 : 0)};
	transition: opacity 120ms ease;
`

// export const OverlayCard = styled.div`
// 	width: 15rem;
// 	max-width: 15rem;
// 	background: ${({ theme }) => theme.palette.background.white};
// 	border: 1px solid rgba(15, 23, 42, 0.12);
// 	border-radius: ${Spacings.SPACING_3B};
// 	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
// 	box-shadow: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_10B} rgba(15, 23, 42, 0.18);

// 	${CardTitle} {
// 		font-size: ${Text.MEDIUM};
// 		line-height: ${Spacings.SPACING_5B};
// 	}

// 	${CardMeta} {
// 		font-size: ${Text.SMALL};
// 		line-height: ${Spacings.SPACING_4B};
// 	}
// `

export const OverlayColumn = styled.div`
	width: 20rem;
	background: ${({ theme }) => theme.palette.background.light};
	border: 1px solid rgba(15, 23, 42, 0.12);
	border-radius: ${Spacings.SPACING_4B};
	padding: ${Spacings.SPACING_3B};
	font-weight: ${Text.BOLD_700};
	box-shadow: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_10B} rgba(15, 23, 42, 0.18);
`
export const CardHeaderRow = styled.div`
	display: flex;
	// flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 8px;

	min-width: 0;
`

export const CardMenuButton = styled.button`
	flex: 0 0 auto;
	width: ${Spacings.SPACING_7B};
	height: ${Spacings.SPACING_7B};
	border-radius: 8px;
	border: 1px solid rgba(15, 23, 42, 0.08);
	background: rgba(255, 255, 255, 0.8);
	color: #64748b;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	user-select: none;

	&:hover {
		color: #0f172a;
		border-color: rgba(15, 23, 42, 0.14);
		box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
	}

	&:active {
		transform: translateY(1px);
	}
`

export const TopBar = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: ${Spacings.SPACING_3B};
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	@media ${Devices.tablet} {
		flex-direction: row;
		align-items: flex-end;
		gap: 0;
	}
`
export const LeftSideContent = styled.div`
	display: inline-flex;
	height: ${Spacings.SPACING_10B};
	align-items: center;
	gap: ${Spacings.SPACING_5B};
`

// export const TitleHeader = styled(H5)`
// 	color: ${({ theme }) => theme.palette.text.primary};
// 	font-family: Inter;
// 	font-size: ${Text.XX_LARGE};
// 	font-style: normal;
// 	font-weight: ${Text.BOLD_700};
// 	line-height: ${Spacings.SPACING_8B};
// `

export const FilterWapper = styled.div`
	display: flex;
	gap: 5px;
	width: 100%;
	align-items: flex-end;
	> * {
		width: 100%;
	}
	> * > * {
		width: 100%;
	}
	flex-direction: column;
	@media ${Devices.mobile} {
		flex-direction: row;
		> * {
			width: auto;
		}
		> * > * {
			width: auto;
		}
	}
`
export const TopBarLeft = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 5px;
	flex: 10;
	flex-direction: column;
	@media ${Devices.mobile} {
		flex-direction: row;
	}
`
export const TopBarRight = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	justify-content: flex-end;
	width: 100%;
	flex: 2;
	flex-direction: column;
	@media ${Devices.mobile} {
		flex-direction: row;
	}
`

export const FilterInputWapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 0.3125rem;
	border: 1px solid #e4e7e9;
	background: var(--Gray-00, #fff);
	width: 100%;
	> :first-child {
		padding: unset;
	}
	@media ${Devices.tablet} {
		width: auto;
	}
`
export const FilterInput = styled(Input)`
	width: 100%;
	color: var(--Gray-500, #77878f);
	// font-family: 'Public Sans';
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;
	border: none;
	outline: none;
	box-shadow: none;
	background: transparent;
	&:focus,
	&:active {
		outline: none;
		box-shadow: none;
	}
	@media ${Devices.tablet} {
		width: 22.75rem;
	}
`
export const SearchIcon = styled.div`
	color: #555;
	padding: 0px 10px;
	& > svg {
		width: 1.25rem;
		height: 1.25rem;
	}
`
export const FilterButtonIcon = styled(Button)`
	border: 1px solid ${({ theme }) => theme.palette.background.blue};
	min-width: unset;
	height: ${Spacings.SPACING_10B};
`
export const AddButtonIcon = styled(Button)`
	min-width: unset;
	height: ${Spacings.SPACING_10B};
`

export const FilterButton = styled(Button)`
	min-width: 0rem;
`

export const MenuItemWrapper = styled.div`
	position: absolute;
	right: 0;
	top: ${Spacings.SPACING_7B};
	background: ${({ theme }) => theme.palette.background.white};
	border: 1px solid #eee;
	border-radius: 6px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	z-index: 999;
	min-width: ${Spacings.SPACING_20B};
`
export const CardMenuItem = styled.div`
	padding: 5px 12px;
	cursor: pointer;
	font-weight: ${Text.BOLD_600};
	font-size: ${Text.SMALL};
	color: ${(p) => (p.danger ? p.theme.palette.text.red : p.theme.palette.text.primary)};
`
export const CategoryWapper = styled.div`
	display: flex;
	gap: 5px;
	flex-wrap: wrap;
	max-width: 100%;
`

export const SearchWrapper = styled.div`
	order: 3;
	width: 100%;
	@media ${Devices.tablet} {
		order: 0;
		width: auto;
	}
`

export const ActionButtonWapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	align-items: stretch;
	order: 1;
	width: 100%;
	> :first-child {
		width: 100%;
	}
	@media ${Devices.tablet} {
		flex-direction: row;
		flex-wrap: nowrap;
		width: auto;
		align-items: flex-end;
		order: 0;
		> :first-child {
			width: auto;
		}
	}
`
export const ButtonFilterWapper = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	align-items: center;
	width: 100%;
	> * {
		flex: 1;
		justify-content: center;
	}
	@media ${Devices.tablet} {
		width: auto;
		> * {
			flex: none;
			justify-content: flex-start;
		}
	}
`

export const MobileColumnNav = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${Spacings.SPACING_2B} 0;
	@media ${Devices.mobile} {
		display: none;
	}
`

export const MobileNavBtn = styled.button`
	background: none;
	border: 1px solid rgba(15, 23, 42, 0.12);
	border-radius: 8px;
	width: 2rem;
	height: 2rem;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	font-size: 1rem;
	color: ${({ theme }) => theme.palette.text.primary};
	&:disabled {
		opacity: 0.3;
		cursor: default;
	}
`

export const MobileColumnDots = styled.div`
	display: flex;
	gap: 4px;
`

export const MobileColumnDot = styled.div`
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: ${({ $active, theme }) => ($active ? theme.palette.secondary.main : 'rgba(15,23,42,0.15)')};
	transition: background 150ms ease;
`
